<sk-upshop-loading-indicator
	*ngIf="iframeEmbed.isIframeEmbed"
	[class.sk-upshop-loading-indicator--compact]="compactUpshop"></sk-upshop-loading-indicator>
<g sk-animated-cart-spinner *ngIf="!iframeEmbed.isIframeEmbed" [scale]="scale"></g>
